/* jshint esnext: true */

/**
 * A generic modal library.
 */
const modalsController = {

	set: function( modal = null ) {

		if ( !modal ) {
			return;
		}

		switch ( modal ) {

			case 'pause':

				gameTimer.pause();

				break;

		}

	}

};